/** Rewinding must publish immediately, even if the prior media time was later. */
export function publishMediaClock(
  now: number,
  previous: number,
  exact = false,
) {
  return exact || now < previous || now - previous >= 33;
}
